import { FC, PropsWithChildren } from "react";
import { CPLModules } from "cpl-react-common/components/Enums/CPLModules";
import { container } from "setup/dependency/inversify.config";
import { ISessionService } from "services/SessionService";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { Navigate } from "react-router-dom";

type Props = {
  module: CPLModules;
  showErrorPage?: boolean;
};

export const CPLModule: FC<PropsWithChildren<Props>> = ({ children, module, showErrorPage }) => {
  const permitted = checkUserHasModule(module);
  return <>{permitted ? children : showErrorPage ? <Navigate to="/error/404" /> : <></>}</>;
};

function checkUserHasModule(moduleID: number): boolean {
  const sessionService = container.get<ISessionService>(SERVICE_TYPES.SessionService);
  const modules = sessionService.getUserModules();
  if (modules.length < 1) {
    return false;
  }

  const module = modules.find((module) => module === moduleID);
  if (module !== null && module !== undefined) {
    return true;
  }
  return false;
}
